module.exports = __webpack_public_path__ + "static/media/UP.237feb81.jpg";